import {
  IBannerList,
  IHomeTabs,
  IMenu,
  ISubjectTags
} from '@/schemas/operation';
import { ICouponPopUpDataItem, ICouponPopupQuery } from '@schemas/coupon';
import { ISubjects } from '@/schemas/video';
import * as services from '@services/index';
import { IPopupActivity } from '@/schemas/activities';

interface State {
  tabs: IHomeTabs;
  tagsList: ISubjectTags;
  headlines: ISubjects;
  menus: IMenu[];
  serviceMenus: IMenu[];
  banner: IBannerList;
  tabBarTop: number;
  popupCoupon: ICouponPopUpDataItem[];
  popupActtivities: IPopupActivity[];
}

const initState: State = {
  tabs: [],
  tagsList: [],
  headlines: [],
  menus: [],
  serviceMenus: [],
  banner: [],
  tabBarTop: 0,
  popupCoupon: [],
  popupActtivities: []
};

const home = {
  state: initState,

  reducers: {
    updateState(state: State, payload) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (_dispatch) => ({
    async getTabs() {
      try {
        const result = await services.operation.getHomeTabs();
        this.updateState({
          tabs: result
        });
      } catch (err) {
        this.updateState({
          tabs: []
        });
      }
    },

    async getSubjectTags() {
      try {
        const result = await services.operation.getSubjectTags();
        this.updateState({
          tagsList: result
        });
      } catch (err) {
        // this.updateState({
        //   tagsList: []
        // });
      }
    },

    async getHeadlines() {
      try {
        const result = await services.operation.getHeadlines();
        this.updateState({
          headlines: result || []
        });
      } catch (err) {
        // nothing
      }
    },

    async getServiceMenu() {
      try {
        const result = await services.operation.getServiceMenu();
        this.updateState({
          serviceMenus: result
        });
      } catch (err) {
        // nothing
      }
    },

    async getMenu() {
      try {
        const result = await services.operation.getMenu();
        this.updateState({
          menus: result
        });
      } catch (err) {
        // nothing
      }
    },

    async getBanner() {
      try {
        const result = await services.operation.getBannerList();
        this.updateState({
          banner: result
        });
      } catch (err) {
        // nothing
      }
    },

    async getModals({
      activityCodeList,
      doctorId,
      actionType
    }: Omit<ICouponPopupQuery, 'showLoading'>) {
      try {
        const couponRes = await services.coupon.queryCouponPopupInfo({
          activityCodeList,
          doctorId,
          actionType,
          showLoading: false
        });

        this.updateState({
          popupCoupon: couponRes || []
        });

        const activitiesRes = await services.activities.getPopupActivities();

        this.updateState({
          popupActtivities: activitiesRes || []
        });
      } catch (error) {
        Promise.reject(error);
      }
    }
  })
};

export default home;
